var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.4426 12C23.4426 18.6274 18.1948 24 11.7213 24C5.24781 24 0 18.6274 0 12C0 5.37258 5.24781 0 11.7213 0C18.1948 0 23.4426 5.37258 23.4426 12Z",
    fill: "#0052FF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.7191 7.79041C9.44102 7.79041 7.59586 9.67432 7.59586 12.0002C7.59586 14.3262 9.44102 16.2101 11.7191 16.2101C13.7601 16.2101 15.454 14.691 15.7805 12.7019H19.9346C19.5841 17.024 16.0416 20.4199 11.7191 20.4199C7.16636 20.4199 3.47266 16.6486 3.47266 12.0002C3.47266 7.35189 7.16636 3.58058 11.7191 3.58058C16.0416 3.58058 19.5841 6.97651 19.9346 11.2986H15.777C15.4506 9.30946 13.7601 7.79041 11.7191 7.79041Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCLogo);
export default __webpack_public_path__ + "static/media/c-logo.d50b0c26ab39cd86f4d006abf2045789.svg";
export { ForwardRef as ReactComponent };